if (!customElements.get('main-product-form')) {
  customElements.define('main-product-form', class ProductForm extends BaseElement {
    constructor ()
    {
      super();

      this.submitLock = false;
      this.initEvents();
    }

    init ()
    {
      this.querySelectorAll('.product-form-variants-item').forEach(item => {
        const input = item.querySelector('input');

        input.addEventListener('change', e => {
          this.updateVariants();
          this.handleAutoChoose(item);
        });
      });

      this.initMobile();
      this.addVariantPrices();
      this.initViews();
      this.updateVariants();
      this.initBuyOptions();
      this.initBuyButton();
    }

    initEvents ()
    {
      this.initErrors();

      this.onBroadcast('treatment_country', async data => {
        await this.checkQuotaExceeded(data);
        this.updateVariants();
        this.updateErrors();
      });

      // Re-evaluate per-variant stock when the AU state changes (no quota check —
      // AU state availability is stock-only).
      this.onBroadcast('treatment_au_state_change', () => {
        this.updateVariants();
        this.updateErrors();
      });

      this.onBroadcast('variant_change', () => {
        this.querySelectorAll('.product-form-buy-option-quantity input').forEach(input => input.value = 0);
        this.updateErrors();
      });
    }

    initMobile ()
    {
      const mobile = document.querySelector('.product-form-mobile');

      mobile.querySelector('.product-form-mobile-buy-button').addEventListener('click', e => {
        e.preventDefault();

        document.body.classList.toggle('show-product-form');
      });

      document.body.appendChild(mobile);

      this.querySelector('.product-form-close').addEventListener('click', e => {
        e.preventDefault();

        this.classList.remove('reservation-mode');
        this.querySelectorAll('.product-form-variants-item-low-stock input').forEach(input => {
          input.disabled = false;
        });
        document.body.classList.remove('show-product-form');
        this.querySelectorAll('.product-form-view').forEach(view => view.style.display = 'none');
        this.querySelector('.product-form-view-main').style.display = 'block';
      });

      this.querySelector('.product-form-buy-button').addEventListener('click', e => {
        document.body.classList.remove('show-product-form');
      });

      document.querySelector('.product-page-right').addEventListener('click', e => {
        if (e.customStopPropagation !== 'popup') {
          document.body.classList.remove('show-product-form');
        }
      });

      document.querySelectorAll('.product-page-right > section').forEach(section => {
        section.addEventListener('click', e => {
          e.customStopPropagation = 'popup';
        });
      });
    }

    getPregnancyQuotaInput (country)
    {
      const pregnancyQuotaVariant = app.pregnancyQuotas.getPregnancyQuotaVariant(country, undefined, window.productData.globalFamilyLimit);
      const container = this.querySelector('[data-pregnancy-quota-country="' + pregnancyQuotaVariant.country + '"]');

      return container.querySelector('[name="properties[__pregnancy_quota]"]');
    }

    // True when the cart already holds a pregnancy quota covering this donor
    // product: a PregnancyQuota line anchored via __line_item_local_id to a
    // LIVING donor line of the product. Property stamps alone don't count —
    // they outlive the donor line they belonged to. Same coverage rule as the
    // cart page (validatePregnancyQuotas / cart-table.liquid pq_present).
    async hasCartPregnancyQuotaForProduct (productId)
    {
      const cart = await fetch(window.Shopify.routes.root + 'cart.json', fetchConfig('javascript'))
        .then(response => response.json());

      if (!cart.items || cart.items.length === 0) {
        return false;
      }

      return cart.items.some(quota => quota.product_type === 'PregnancyQuota'
        && quota.properties
        && quota.properties.__line_item_local_id
        && cart.items.some(donor => donor.product_type === 'Donor'
          && donor.product_id == productId
          && donor.properties
          && donor.properties.__item_local_id === quota.properties.__line_item_local_id));
    }

    addVariantPrices ()
    {
      this.querySelectorAll('.product-form-variants-item').forEach(item => {
        const radios = item.closest('variant-radios');
        const input = item.querySelector('input');
        const variant = radios.getVariantData().find(variant => {
          return variant.option1 === input.value;
        });

        item.querySelector('.product-form-variants-item-price').innerHTML = app.money(variant.price / 100);
      });
    }

    initViews ()
    {
      this.querySelector('.product-form-view-purchase .product-form-selected-variant-body').addEventListener('click', e => {
        e.preventDefault();

        this.querySelectorAll('.product-form-view').forEach(view => view.style.display = 'none');
        this.querySelector('.product-form-view-variants').style.display = 'block';

      });

      this.querySelector('.product-form-view-reservation .product-form-selected-variant-body').addEventListener('click', e => {
        e.preventDefault();

        this.querySelectorAll('.product-form-view').forEach(view => view.style.display = 'none');
        this.querySelector('.product-form-view-variants').style.display = 'block';
      });

      this.querySelector('.product-form-view-variants-back').addEventListener('click', e => {
        e.preventDefault();

        this.querySelectorAll('.product-form-view').forEach(view => view.style.display = 'none');

        if (this.classList.contains('is-reservation')) {
          this.querySelector(`.product-form-view-reservation`).style.display = 'block';
        } else if (this.classList.contains('is-purchase')) {
          this.querySelector(`.product-form-view-purchase`).style.display = 'block';
        }
      });


      this.querySelector('.product-form-buy-method--purchase').addEventListener('click', e => {
        e.preventDefault();

        this.classList.remove('reservation-mode');
        this.querySelectorAll('.product-form-variants-item-low-stock input').forEach(input => {
          input.disabled = false;
        });
        this.querySelectorAll('.product-form-view').forEach(view => view.style.display = 'none');
        this.querySelector('.product-form-view-purchase').style.display = 'block';
        this.querySelector('.product-form-view-variants-reservation').style.display = 'none';
        this.classList.add('is-purchase');
        this.classList.remove('is-reservation');

        // Restore sold out for purchase
        this.querySelectorAll('.product-form-variants-item').forEach(item => {
          if (item.dataset.isAvailable === false || item.dataset.isAvailable === 'false') {
            item.classList.add('product-form-variants-item-sold-out');
            item.querySelector('.product-form-variants-item-tag-sold-out')?.classList.remove('hidden');
          }

          if (item.dataset.isDisabled === true || item.dataset.isDisabled === 'true') {
            const input = item.querySelector('input');

            item.classList.add('disabled');
            input.disabled = true;

            if (input.checked) {
              input.checked = false;
              input.dispatchEvent(new Event('change'));
            }
          }
        });

        this.updateErrors();
      });

      this.querySelector('.product-form-view-purchase-back').addEventListener('click', e => {
        e.preventDefault();

        this.classList.remove('reservation-mode');
        this.querySelectorAll('.product-form-view').forEach(view => view.style.display = 'none');
        this.querySelector('.product-form-view-main').style.display = 'block';
        this.classList.remove('is-purchase');
      });

      this.querySelector('.product-form-buy-method--reservation').addEventListener('click', e => {
        e.preventDefault();

        this.classList.add('reservation-mode');
        this.querySelectorAll('.product-form-view').forEach(view => view.style.display = 'none');
        this.querySelector('.product-form-view-reservation').style.display = 'block';
        this.querySelector('.product-form-view-variants-reservation').style.display = 'block';
        this.classList.add('is-reservation');
        this.classList.remove('is-purchase');

        // Disable low-stock variant inputs for reservation (purchase only)
        this.querySelectorAll('.product-form-variants-item-low-stock input').forEach(input => {
          input.disabled = true;

          if (input.checked) {
            input.checked = false;
            input.dispatchEvent(new Event('change'));
          }
        });

        this.updateErrors();
      });

      this.querySelector('.product-form-view-reservation-back').addEventListener('click', e => {
        e.preventDefault();

        this.classList.remove('reservation-mode');
        this.querySelectorAll('.product-form-variants-item-low-stock input').forEach(input => {
          input.disabled = false;
        });
        this.querySelectorAll('.product-form-view').forEach(view => view.style.display = 'none');
        this.querySelector('.product-form-view-main').style.display = 'block';
        this.classList.remove('is-reservation');
      });
    }

    updateVariants ()
    {
      let selected = null;

      this.applyMarketCapVisuals();

      this.querySelectorAll('.product-form-variants-item').forEach(item => {
        const input = item.querySelector('input');

        if (input.checked) {
          selected = item;
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });

      this.updateStrawSetNotice();

      if (selected) {
        this.querySelectorAll('.product-form-selected-variant').forEach(selectedVariant => {
          selectedVariant.classList.add('has-value');

          selectedVariant.querySelector('.product-form-selected-variant-value .value').innerHTML = selected.querySelector('.product-form-variants-item-name').innerHTML;
          selectedVariant.querySelector('.product-form-selected-variant-price').innerHTML = selected.querySelector('.product-form-variants-item-price').innerHTML;

        });

        this.querySelectorAll('.product-form-buy-options').forEach(buyOptions => {
          const max = this.effectiveMaxForVariantItem(selected);
          // Whole sets only (9 in stock → 6 for AU) — purchases AND
          // reservations move in sets for set-rule countries.
          const setSize = this.strawSetSize();

          buyOptions.dataset.maxQuantity = (setSize > 1 && !Number.isNaN(max))
            ? max - (max % setSize)
            : max;
        });
        // this.querySelector('.product-form-selected-variant').classList.add('has-value');
        // this.querySelector('.product-form-selected-variant-value .value').innerHTML = selected.querySelector('.product-form-variants-item-name').innerHTML;
        // this.querySelector('.product-form-selected-variant-price').innerHTML = selected.querySelector('.product-form-variants-item-price').innerHTML;
        // this.querySelector('.product-form-buy-options').dataset.maxQuantity = selected.dataset.variantQuantity;
      } else {

        this.querySelectorAll('.product-form-selected-variant').forEach(selectedVariant => {
          selectedVariant.classList.remove('has-value');
        });
       // this.querySelector('.product-form-selected-variant').classList.remove('has-value');
      }

      this.updateReservation();
    }

    handleAutoChoose (item)
    {
      if (item.querySelector('input').disabled) return;

      if (this._autoChooseTimeout) {
        clearTimeout(this._autoChooseTimeout);
      }

      item.classList.add('is-auto-choosing');

      this._autoChooseTimeout = setTimeout(() => {
        item.classList.remove('is-auto-choosing');

        this.querySelectorAll('.product-form-view').forEach(view => view.style.display = 'none');

        if (this.classList.contains('is-reservation')) {
          this.querySelector('.product-form-view-reservation').style.display = 'block';
        } else if (this.classList.contains('is-purchase')) {
          this.querySelector('.product-form-view-purchase').style.display = 'block';
        }
      }, 400);
    }

    updateReservation ()
    {
      const reservationQuantityInput = this.querySelector('input[name="reservation_quantity"]');
      const totalQuantity = !Number.isNaN(parseInt(reservationQuantityInput.value))
        ? parseInt(reservationQuantityInput.value)
        : 0;
      const formData = new FormData(this.querySelector('form'));
      const reservationVariant = this.getVariant(formData.get('reservation_id'));

      if (reservationVariant) {
        const totalPrice = (reservationVariant.price / 100) * totalQuantity;
        const comparePrice = totalPrice * 2;

        const totalPriceEl = this.querySelector('[data-reservation-total-price]');
        const comparePriceEl = this.querySelector('[data-reservation-compare-price]');

        if (totalPriceEl) totalPriceEl.innerText = app.money(totalPrice);
        if (comparePriceEl) comparePriceEl.innerText = app.money(comparePrice);

        const reservationButton = this.querySelector('.product-form-buy-button--reservation');
        if (reservationButton && totalQuantity > 0) {
          reservationButton.textContent = reservationButton.dataset.addToCartEmptyText + ' · ' + app.money(totalPrice);
        }
      }
    }

    initBuyOptions ()
    {
      this.optionsError = this.querySelector('.product-add-options-error');

      this.querySelectorAll('.product-form-buy-option').forEach(option => {
        const input = option.querySelector('input');
        const minus = option.querySelector('.product-form-buy-option-quantity-minus');
        const plus = option.querySelector('.product-form-buy-option-quantity-plus');

        input.addEventListener('keydown', e => {
          const charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
          const charStr = String.fromCharCode(charCode);

          if (!/^\d*\.?\d*$/.test(charStr)) {
            e.preventDefault();

            return false;
          }
        });

        input.addEventListener('keyup', e => {
          const max = option.closest('.product-form-buy-options').dataset.maxQuantity;
          let current = Number.isNaN(parseInt(input.value)) ? 1 : parseInt(input.value);
          let totalQuantity = 0;

          option.closest('.product-form-buy-options').querySelectorAll('.product-form-buy-option').forEach(opt => {
            if (opt !== option) {
              const val = Number.isNaN(parseInt(opt.querySelector('input').value)) ? 0 : parseInt(opt.querySelector('input').value)

              totalQuantity += val;
            }
          });

          if (max && totalQuantity + current > max) {
            current = max - totalQuantity;

            if (current < 0) {
              current = 0;
            }

            input.value = current;
          }

          this.updateErrors();
        });

        // Hand-typed quantities snap down to a whole set on blur (the keyup
        // handler has already clamped to the max). Applies to ship, bank AND
        // reservation quantities — set-rule countries reserve in whole sets
        // too.
        input.addEventListener('change', e => {
          const step = this.strawSetSize();

          if (step <= 1) {
            return;
          }

          const current = parseInt(input.value);

          if (!Number.isNaN(current) && current % step !== 0) {
            input.value = current - (current % step);

            this.updateErrors();
          }
        });

        minus.addEventListener('click', e => {
          e.preventDefault();

          if (option.classList.contains('disabled')) {
            return;
          }

          const step = this.strawSetSize();
          let current = Number.isNaN(parseInt(input.value)) ? 1 : parseInt(input.value);

          // Down to the next-lower multiple of the set size (plain -1 when no
          // set rule applies), never below 0.
          current = (Math.ceil(current / step) - 1) * step;

          if (current < 0) {
            current = 0;
          }

          input.value = current;

          this.updateErrors();
        });

        plus.addEventListener('click', e => {
          e.preventDefault();

          if (option.classList.contains('disabled')) {
            return;
          }

          const step = this.strawSetSize();
          let current = Number.isNaN(parseInt(input.value)) ? 1 : parseInt(input.value);

          // Up to the next multiple of the set size (plain +1 when no set
          // rule applies).
          current = (Math.floor(current / step) + 1) * step;

          const max = option.closest('.product-form-buy-options').dataset.maxQuantity;
          let totalQuantity = 0;

          option.closest('.product-form-buy-options').querySelectorAll('.product-form-buy-option').forEach(opt => {
            if (opt !== option) {
              const val = Number.isNaN(parseInt(opt.querySelector('input').value)) ? 0 : parseInt(opt.querySelector('input').value)

              totalQuantity += val;
            }
          });

          if (max && totalQuantity + current > max) {
            current = max - totalQuantity;

            if (current < 0) {
              current = 0;
            }

            // Keep the clamped value on a set boundary.
            current = current - (current % step);
          }

          input.value = current;

          this.updateErrors();
        });
      });
    }

    initBuyButton ()
    {
      this.querySelectorAll('.product-form-buy-button').forEach(button => {
        button.addEventListener('click', e => {
          e.preventDefault();

        document.body.classList.remove('show-product-form');

          if (button.classList.contains('disabled')) {
            return;
          }

          this.onSubmit(button.classList.contains('product-form-buy-button--reservation'));
        });
      });
    }

    getVariants ()
    {
      return JSON.parse(this.querySelector('#variants-json').textContent);
    }

    getVariant (id)
    {
      return this.getVariants().find(variant => {
        return variant.id == id;
      });
    }

    getCurrentVariant ()
    {
      let result = null;

      this.querySelectorAll('.product-form-variants-item').forEach(item => {
        if (item.querySelector('input').checked) {
          result = this.getVariant(item.dataset.variantId);
        }
      });

      return result;
    }

    initErrors ()
    {
      this.querySelectorAll('.product-form-buy-button, .product-form-buy-option').forEach(div => {
        div.dataset.originalDisabled = div.classList.contains('disabled') ? 'disabled' : '';
      });
    }

    updateErrors ()
    {
      const currentVariant = this.getCurrentVariant();

      this.querySelectorAll('.product-form-buy-button').forEach(buyButton => {
        const isReservation = buyButton.classList.contains('product-form-buy-button--reservation');
        const quantityName = isReservation ? 'reservation_quantity' : 'ship_quantity';

        // Each button pass governs only ITS view's quantity steppers. Both
        // passes used to run over ALL steppers, so the purchase pass and the
        // reservation pass painted contradictory tooltips onto the same
        // wrappers (e.g. "sold out" stacked on "please choose quantity").
        const buttonView = buyButton.closest('.product-form-view');
        const buyOptions = buttonView
          ? buttonView.querySelectorAll('.product-form-buy-option')
          : this.querySelectorAll('.product-form-buy-option');
        let buyDisabled = false;
        let quantityDisabled = false;
        let buyDisabledReason = null;

        if (!app.customer.residentialCountry) {
          buyButton.classList.add('disabled');
          buyButton.classList.add('disabled-residential');
          buyButton.dataset.tippyTitle = ProductString.SelectResidentialCountry;
          buyDisabledReason = ProductString.SelectResidentialCountry;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          buyButton.classList.remove('disabled-residential');
        }

        // Australia requires a state/territory before purchase (the backend
        // requires it for AU enforcement, and clinic/stock/quota all key off it).
        const treatmentSelection = app.treatmentCountry.getSelection();

        if (!buyDisabled && treatmentSelection.country === 'AU' && !treatmentSelection.state) {
          buyButton.classList.add('disabled');
          buyButton.classList.add('disabled-treatment-state');
          buyButton.dataset.tippyTitle = ProductString.SelectTreatmentState;
          buyDisabledReason = ProductString.SelectTreatmentState;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          buyButton.classList.remove('disabled-treatment-state');
        }

        if (!buyDisabled && !this.isTreatmentAvailable()) {
          document.querySelector('.product-treatment-error-unavailable').classList.remove('hidden');
          buyButton.classList.add('disabled');
          buyButton.classList.add('disabled-treatment');
          buyButton.dataset.tippyTitle = ProductString.TreatmentUnavailable;
          buyDisabledReason = ProductString.TreatmentUnavailable;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          document.querySelector('.product-treatment-error-unavailable').classList.add('hidden');
          buyButton.classList.remove('disabled-treatment');
        }

        if (!buyDisabled && this.isQuotaExceeded()) {
          buyButton.classList.add('disabled');
          buyButton.classList.add('disabled-quota');
          buyButton.dataset.tippyTitle = ProductString.QuotaExceeded;
          buyDisabledReason = ProductString.QuotaExceeded;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          buyButton.classList.remove('disabled-quota');
        }

        if (
          (!buyDisabled && currentVariant && this.isSoldOut(currentVariant.id))
          || (!buyDisabled && currentVariant && this.isBelowOneSet(currentVariant.id))
          || this.isSoldOutAll()
          || this.isInTest()
        ) {
          buyButton.classList.add('disabled');
          buyButton.classList.add('disabled-sold-out');
          buyButton.textContent = ProductString.SoldOut;
          buyButton.dataset.tippyTitle = ProductString.SoldOut;
          buyDisabledReason = ProductString.SoldOut;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          buyButton.textContent = buyButton.dataset.addToCartText;
          buyButton.classList.remove('disabled-sold-out');
        }

        if (!buyDisabled && isReservation && currentVariant && this.isLowStockForReservation(currentVariant.id)) {
          buyButton.classList.add('disabled');
          buyButton.classList.add('disabled-low-stock');
          buyButton.dataset.tippyTitle = ProductString.LowStockReservation;
          buyDisabledReason = ProductString.LowStockReservation;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          buyButton.classList.remove('disabled-low-stock');
        }

        if (!buyDisabled && !currentVariant) {
          buyButton.classList.add('disabled');
          buyButton.classList.add('disabled-variant');
          buyButton.dataset.tippyTitle = ProductString.SelectVariant;
          buyDisabledReason = ProductString.SelectVariant;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          buyButton.classList.remove('disabled-variant');
        }

        if (!buyDisabled) {
          let totalQuantity = 0;
          const quantityNames = isReservation ? [quantityName] : ['ship_quantity', 'bank_quantity'];

          quantityNames.forEach(name => {
            this.querySelectorAll(`.product-form-buy-option input[name="${name}"]`).forEach(input => {
              totalQuantity += !Number.isNaN(parseInt(input.value))
                ? parseInt(input.value)
                : 0;
            });
          });

          if (totalQuantity === 0) {
            buyButton.classList.add('disabled');
            buyButton.classList.add('disabled-quantity');
            buyButton.dataset.tippyTitle = ProductString.VariantQuantity

            if (buyButton.dataset.addToCartEmptyText) {
              buyButton.textContent = buyButton.dataset.addToCartEmptyText;
            }

            buyDisabledReason = ProductString.VariantQuantity;
            buyDisabled = true;
            quantityDisabled = false;

            if (isReservation) {
              this.querySelectorAll('.product-form-view-reservation-summary').forEach(summary => summary.classList.add('hidden'));
            }
          } else if (this.hasStrawSetMisalignment(quantityNames)) {
            // A quantity that isn't a whole set (only reachable by typing —
            // the steppers and blur-snap keep values aligned). quantityNames
            // is per-button, so this covers ship+bank on the purchase button
            // and reservation_quantity on the reservation button.
            const strawSetError = this.strawSetQuantityError();

            buyButton.classList.add('disabled');
            buyButton.classList.add('disabled-quantity');
            buyButton.dataset.tippyTitle = strawSetError;
            buyButton.textContent = buyButton.dataset.addToCartText;
            buyDisabledReason = strawSetError;
            buyDisabled = true;
            quantityDisabled = false;
          } else {
            buyButton.classList.remove('disabled-quantity');
            buyButton.textContent = buyButton.dataset.addToCartText;
          }

          if (isReservation) {
            this.updateReservation();
          }
        } else {
          if (isReservation) {
            this.querySelectorAll('.product-form-view-reservation-summary').forEach(summary => summary.classList.add('hidden'));
          }
        }

        // initTippy() overwrites .tippyInstance without destroying the old
        // instance, which leaves the previous tooltip alive on the element
        // (stacked/overlapping tooltips) — always destroy before a re-init
        // can happen.
        const destroyQuantityTooltip = (quantity) => {
          quantity.classList.remove('tippy-initialized');

          if (quantity.tippyInstance) {
            quantity.tippyInstance.destroy();
            quantity.tippyInstance = null;
          }
        };

        const unlockQuantity = () => {
          buyOptions.forEach(buyOption => {
            const quantity = buyOption.querySelector('.product-form-buy-option-quantity');

            buyOption.classList.remove('disabled');
            buyOption.querySelector('input').disabled = false;
            destroyQuantityTooltip(quantity);
            delete quantity.dataset.tippyTitle;
          });
        };

        buyButton.classList.remove('tippy-initialized');

        if (buyButton.tippyInstance) {
          buyButton.tippyInstance.destroy();
          buyButton.tippyInstance = null;
        }

        if (!buyDisabled) {
          if (buyButton.dataset.originalDisabled === 'disabled') {
            buyButton.classList.add('disabled');
          } else {
            buyButton.classList.remove('disabled');
          }

          delete buyButton.dataset.tippyTitle;

          unlockQuantity();
        } else if (quantityDisabled) {
          buyOptions.forEach(buyOption => {
            const quantity = buyOption.querySelector('.product-form-buy-option-quantity');

            buyOption.classList.add('disabled');
            buyOption.querySelector('input').disabled = true;
            destroyQuantityTooltip(quantity);

            if (buyDisabledReason) {
              quantity.dataset.tippyTitle = buyDisabledReason;
            } else {
              delete quantity.dataset.tippyTitle;
            }
          });
        } else {
          unlockQuantity();
        }
      });

      app.initTippy();
    }

    isSoldOut (variantId)
    {
      if (!this.getVariant(variantId).available) {
        return true;
      }

      // When the treatment country is gated by the donor.market_stock
      // metafield (e.g. UK in V1), a zero per-variant count counts as sold out
      // for the buyer's selected treatment country even if Shopify's native
      // inventory has stock.
      const item = this.querySelector(`.product-form-variants-item[data-variant-id="${variantId}"]`);
      const marketCap = this.marketCapForVariantItem(item);
      if (marketCap !== null && marketCap <= 0) {
        return true;
      }

      return false;
    }

    /**
     * Returns the donor.market_stock sub-key to gate against for the current
     * treatment selection, or null when not gated. This is the listed country
     * code (e.g. "gb"), or for Australia the selected state code (e.g.
     * "au-nsw") — AU is gated per state. Status-quo path returns null.
     */
    currentGatedTreatmentCountry ()
    {
      if (!app.treatmentCountry) {
        return null;
      }

      return app.treatmentCountry.marketStockKey(
        (window.productData && window.productData.gatedTreatmentCountries) || [],
      );
    }

    /**
     * Read the per-market straw count for the given variant pill from its
     * `data-market-stock` attribute. Returns:
     *  - a number when the current treatment country is gated and a count
     *    exists for it,
     *  - null when the treatment country is not gated, the pill has no
     *    `data-market-stock` data, or the parsed value is malformed.
     */
    marketCapForVariantItem (item)
    {
      if (!item) {
        return null;
      }

      const gatedCountry = this.currentGatedTreatmentCountry();
      if (!gatedCountry) {
        return null;
      }

      const raw = item.dataset.marketStock;
      if (!raw) {
        return null;
      }

      let parsed;
      try {
        parsed = JSON.parse(raw);
      } catch (e) {
        return null;
      }

      // The backend (SyncStock) only writes market keys for markets with
      // compliant straws, so for a gated market a MISSING key means zero
      // purchasable straws — fail closed. (Fail-open here let variants with
      // no AU/GB allocation sell into those markets at native inventory.)
      // A wholly missing metafield still returns null above: that's a donor
      // the hourly sync hasn't written yet, or a Fairfax donor gated by
      // tags instead.
      const value = parsed[gatedCountry];
      return typeof value === 'number' ? value : 0;
    }

    /**
     * Effective add-to-cart cap for a variant pill: the lower of the native
     * variant inventory and the per-market cap (when applicable).
     */
    effectiveMaxForVariantItem (item)
    {
      const variantQuantity = parseInt(item.dataset.variantQuantity);
      const marketCap = this.marketCapForVariantItem(item);

      if (marketCap === null) {
        return variantQuantity;
      }

      if (Number.isNaN(variantQuantity)) {
        return marketCap;
      }

      return Math.min(variantQuantity, marketCap);
    }

    /**
     * Straw-set size for the current treatment selection (e.g. 6 for AU).
     * 1 = no set rule. Applies to ship, bank AND reservation quantities —
     * set-rule countries reserve in whole sets too.
     */
    strawSetSize ()
    {
      return window.app && window.app.strawSets
        ? window.app.strawSets.sizeForSelection()
        : 1;
    }

    /**
     * Fewer available straws than one whole set for the current selection:
     * neither a purchase nor a reservation can form a set, so both buy
     * buttons show sold out. Kept separate from isSoldOut() so the
     * set-specific reason stays greppable.
     */
    isBelowOneSet (variantId)
    {
      const setSize = this.strawSetSize();

      if (setSize <= 1) {
        return false;
      }

      const item = this.querySelector(`.product-form-variants-item[data-variant-id="${variantId}"]`);

      if (!item) {
        return false;
      }

      const max = this.effectiveMaxForVariantItem(item);

      // NaN = inventory not tracked = effectively unlimited.
      return !Number.isNaN(max) && max < setSize;
    }

    hasStrawSetMisalignment (quantityNames)
    {
      const step = this.strawSetSize();

      if (step <= 1) {
        return false;
      }

      let misaligned = false;

      quantityNames.forEach(name => {
        this.querySelectorAll(`.product-form-buy-option input[name="${name}"]`).forEach(input => {
          const value = parseInt(input.value);

          if (!Number.isNaN(value) && value % step !== 0) {
            misaligned = true;
          }
        });
      });

      return misaligned;
    }

    strawSetQuantityError ()
    {
      return ((window.ProductString && ProductString.StrawSetQuantity) || 'Straws are sold in sets of [quantity].')
        .replace('[quantity]', this.strawSetSize());
    }

    // Informational line above the quantity steppers ("sold in sets of 6"),
    // shown only while a set rule applies to the current selection.
    updateStrawSetNotice ()
    {
      const setSize = this.strawSetSize();

      this.querySelectorAll('[data-straw-set-notice]').forEach(notice => {
        if (setSize > 1) {
          notice.textContent = (notice.dataset.strawSetNoticeTemplate || '').replace('[quantity]', setSize);
          notice.classList.remove('hidden');
        } else {
          notice.classList.add('hidden');
        }
      });
    }

    /**
     * Visually mark variants as sold-out AND block selection when the selected
     * treatment country is gated and the per-variant count is 0. Idempotent:
     * clears the class and restores the original `disabled` state of the
     * radio when the treatment country is not gated, so navigation back to a
     * non-gated country returns the picker to its native state. The original
     * (Liquid-set) disabled state is captured on first run via
     * `data-original-disabled` so a natively-unavailable variant stays
     * disabled even after we clear our own market-disable.
     */
    applyMarketCapVisuals ()
    {
      const gatedCountry = this.currentGatedTreatmentCountry();

      this.querySelectorAll('.product-form-variants-item').forEach(item => {
        const radio = item.querySelector('input[type="radio"]');

        if (radio && typeof radio.dataset.originalDisabled === 'undefined') {
          radio.dataset.originalDisabled = radio.disabled ? '1' : '';
        }

        const marketCap = gatedCountry ? this.marketCapForVariantItem(item) : null;
        const isMarketUnavailable = marketCap !== null && marketCap <= 0;

        if (isMarketUnavailable) {
          item.classList.add('product-form-variants-item-market-unavailable');
        } else {
          item.classList.remove('product-form-variants-item-market-unavailable');
        }

        if (radio) {
          if (isMarketUnavailable) {
            radio.disabled = true;
          } else {
            // Restore Liquid's original disabled state — never re-enable a
            // natively-unavailable variant.
            radio.disabled = radio.dataset.originalDisabled === '1';
          }
        }
      });
    }

    isLowStockForReservation (variantId)
    {
      const variantItem = this.querySelector(`.product-form-variants-item[data-variant-id="${variantId}"]`);
      if (!variantItem) return false;
      return variantItem.dataset.lowStock === 'true';
    }

    isSoldOutAll ()
    {
      let soldOut = true;

      this.querySelectorAll('.product-form-variants-item').forEach(item => {
        if (!item.classList.contains('product-form-variants-item-sold-out')) {
          soldOut = false;
        }
      });

      return soldOut;
    }

    // Donors in the active new-donor test rotation are presented as sold out.
    // The flag is computed server-side (snippets/donor-test-status.liquid) and
    // passed down as data-in-test so the buy button greys out like any other
    // out-of-stock donor, without touching real Shopify inventory.
    isInTest ()
    {
      return this.dataset.inTest === 'true';
    }

    isQuotaExceeded ()
    {
      const pqError = document.querySelector('.product-treatment-error-quota-exceeded');
      const pqInput = this.getPregnancyQuotaInput();

      if (!pqError || !pqInput) {
        return false;
      }

      if (!pqInput.checked) {
        return false;
      }
      return pqError && !pqError.classList.contains('hidden');
    }

    isTreatmentAvailable ()
    {
      const selection = app.treatmentCountry.getSelection();

      if (!selection.country) {
        return false;
      }

      if (this.customerHasQuota) {
        return true;
      }

      const countryCode = selection.country.toLowerCase();
      const countries = JSON.parse(document.querySelector('#product-treatment-country').dataset.countries);
      const countryAvailable = typeof(countries[countryCode]) !== 'undefined'
        && countries[countryCode].available;

      if (!countryAvailable) {
        return false;
      }

      // For Australia, the chosen state must also be available for this donor.
      if (selection.country === 'AU' && selection.state) {
        const stateSelect = document.querySelector('.product-treatment-state select');
        const states = stateSelect && stateSelect.dataset.states
          ? JSON.parse(stateSelect.dataset.states)
          : {};
        const stateKey = selection.state.toLowerCase();

        return typeof(states[stateKey]) !== 'undefined' && states[stateKey].available;
      }

      return true;
    }

    async checkQuotaExceeded (data)
    {
      const quotaExceededDiv = this.querySelector('.product-form-quota');

      if (!quotaExceededDiv) {
        return;
      }

      this.querySelectorAll('.product-form-addons-quotas .product-form-addons-item').forEach(quota => quota.classList.add('hidden'));
      this.getPregnancyQuotaInput()
        .closest('.product-form-addons-quotas .product-form-addons-item')
        .classList.remove('hidden');

      const donor = window.productData.title;

      const response = await fetch('https://app.donornetwork.com/api/shopify/customer/quota-available?treatment_country=' + data.code + '&residence_country=' + app.customer.residentialCountry.toUpperCase() + "&donor=" + donor + app.treatmentCountry.stateQueryParam(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...app.apiHeaders(),
        },
      });
      const dataResponse = await response.json();
      app.pregnancyQuotas.rememberQuotaVariantCountry(data.code, app.customer.residentialCountry, dataResponse.data.quota_variant_country);
      const hasQuota = dataResponse.data.customer_has_quota;
      this.customerHasQuota = hasQuota;
      this.getPregnancyQuotaInput().checked = !hasQuota;
      if (dataResponse.data.quota_available || hasQuota) {
        quotaExceededDiv.classList.remove('show');
        document.querySelector('.product-treatment-error-quota-exceeded').classList.add('hidden');

        this.querySelectorAll('.product-form-buy-option-quantity').forEach(div => {
          if (div.dataset.originalDisabled === 'disabled') {
            div.classList.add('disabled', 'tippy-initialized');
            div.querySelector('input').disabled = true;
          } else {
            div.classList.remove('disabled', 'tippy-initialized');
            div.querySelector('input').disabled = false;
          }

          if (div.tippyInstance) {
            div.tippyInstance.destroy();
          }
        });

        this.querySelectorAll('.product-form-buy-button').forEach(div => {
          if (div.dataset.originalDisabled === 'disabled') {
            div.classList.add('disabled', 'tippy-initialized');
          } else {
            div.classList.remove('disabled', 'tippy-initialized');
          }

          if (div.tippyInstance) {
            div.tippyInstance.destroy();
          }
        });

        const countries = JSON.parse(document.querySelector('#product-treatment-country').dataset.countries);

        if (!countries[data.code.toLowerCase()].available) {
          document.querySelector('.product-treatment-error-unavailable').classList.remove('hidden');
        }
        return;
      }
      
      this.querySelectorAll('.product-form-buy-button, .product-form-buy-option-quantity').forEach(div => {
        if (typeof(div.dataset.originalDisabled) === 'undefined') {
          div.dataset.originalDisabled = div.classList.contains('disabled') ? 'disabled' : '';
        }

        div.classList.remove('disabled-quota');
      });

      document.querySelectorAll('.product-treatment-error:not(.active)').forEach(div => div.classList.add('hidden'));

      quotaExceededDiv.classList.add('show');
      document.querySelector('.product-treatment-error-quota-exceeded').classList.remove('hidden');

      window.app.initTippy();
    }

    // Serialize submissions. The buy flow is a multi-request async chain with
    // no visual progress until the cart notification opens, so a double-click
    // (or impatient re-click) used to run two full flows concurrently —
    // duplicating the donor lines AND racing both flows past the pregnancy-
    // quota dedup into a double quota charge. One flow at a time; the lock is
    // a field (not the 'disabled' class) so updateErrors() can't clear it.
    async onSubmit (isReservation)
    {
      if (this.submitLock) {
        return;
      }

      this.submitLock = true;
      this.querySelectorAll('.product-form-buy-button').forEach(button => button.classList.add('is-submitting'));

      try {
        await this.doSubmit(isReservation);
      } finally {
        this.submitLock = false;
        this.querySelectorAll('.product-form-buy-button').forEach(button => button.classList.remove('is-submitting'));
      }
    }

    async doSubmit (isReservation)
    {
      const treatmentCountry = window.app.treatmentCountry.getSelection().country;
      const residentialCountry = app.customer.residentialCountry;

      if (treatmentCountry && residentialCountry) {
        try {
          const donor = window.productData.title;
          const response = await fetch('https://app.donornetwork.com/api/shopify/customer/quota-available?treatment_country=' + treatmentCountry.toUpperCase() + '&residence_country=' + residentialCountry.toUpperCase() + '&donor=' + donor + app.treatmentCountry.stateQueryParam(), {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              ...app.apiHeaders(),
            },
          });
          const quotaData = await response.json();
          app.pregnancyQuotas.rememberQuotaVariantCountry(treatmentCountry, residentialCountry, quotaData.data.quota_variant_country);

          if (!quotaData.data.quota_available && !quotaData.data.customer_has_quota) {
            await this.checkQuotaExceeded({ code: treatmentCountry });
            this.updateErrors();
            return;
          }
        } catch (err) {
          console.error('Quota availability check failed:', err);
        }
      }

      const config = fetchConfig('javascript');
      const formData = new FormData(this.querySelector('form'));

      // Hard guard: never send a non-whole-set straw quantity for a set-rule
      // country — purchases AND reservations. The steppers, blur-snap and
      // updateErrors() make this unreachable through the UI; this catches
      // anything they missed.
      const strawSetGuardSize = this.strawSetSize();

      if (strawSetGuardSize > 1) {
        const strawQuantities = isReservation
          ? [parseInt(formData.get('reservation_quantity')) || 0]
          : [
            parseInt(formData.get('ship_quantity')) || 0,
            parseInt(formData.get('bank_quantity')) || 0
          ];

        if (strawQuantities.some(quantity => quantity % strawSetGuardSize !== 0)) {
          if (this.optionsError) {
            this.optionsError.textContent = this.strawSetQuantityError();
            this.optionsError.classList.add('show');
          }

          return;
        }
      }

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const data = {
        items: []
      };
      let shipItem = null;
      let bankItem = null;
      let reservationItem = null;

      if (cart) {
        cart.setActiveElement(document.activeElement);
      }

      if (isReservation) {
        if (formData.get('reservation_quantity') > 0) {
          const sellingPlanId = formData.get('reservation_selling_plan_id');
          reservationItem = {
            id: formData.get('reservation_id'),
            quantity: parseInt(formData.get('reservation_quantity')),
            ...(sellingPlanId ? { selling_plan: parseInt(sellingPlanId) } : {}),
            properties: {
              __item_local_id: Date.now().toString(36) + Math.random().toString(36).substring(2),
              __reservation_variant_id: formData.get('id'),
              __reservation_quantity: formData.get('reservation_quantity'),
              __treatment: treatmentCountry,
              // Reservations carry a pregnancy-quota requirement just like ship/bank
              // donor lines. One PQ still covers all cart lines of the same donor
              // product (ship + bank + reservation) — the per-product dedup below and
              // the cart-page gate both key on product_id, not on the line.
              __pregnancy_quota: this.getPregnancyQuotaInput().value,
              'Of': formData.get('reservation_quantity') + 'x ' + this.getVariant(formData.get('id')).title
            }
          };
          data.items.push(reservationItem);
        }
      } else {
        if (formData.get('ship_quantity') > 0) {
          shipItem = {
            id: formData.get('id'),
            quantity: formData.get('ship_quantity'),
            properties: {
              __item_local_id: Date.now().toString(36) + Math.random().toString(36).substring(2),
              __treatment: treatmentCountry,
              __shipping: 'clinic',
              __pregnancy_quota: this.getPregnancyQuotaInput().value
            }
          };

          if (formData.get('properties[__genetic_matching]')) {
            shipItem.properties.__genetic_matching = formData.get('properties[__genetic_matching]');
          }

          if (formData.get('custom_terms')) {
            shipItem.properties.__custom_terms = formData.get('custom_terms');
          }

          data.items.push(shipItem);
        }

        if (formData.get('bank_quantity') > 0) {
          bankItem = {
            id: formData.get('id'),
            quantity: formData.get('bank_quantity'),
            properties: {
              __item_local_id: Date.now().toString(36) + Math.random().toString(36).substring(2),
              __treatment: treatmentCountry,
              __shipping: 'bank',
              __pregnancy_quota: this.getPregnancyQuotaInput().value
            }
          };

          if (formData.get('properties[__genetic_matching]')) {
            bankItem.properties.__genetic_matching = formData.get('properties[__genetic_matching]');
          }

          if (formData.get('custom_terms')) {
            bankItem.properties.__custom_terms = formData.get('custom_terms');
          }

          data.items.push(bankItem);
        }
      }

      if (data.items.length === 0) {
        return;
      }

      // The pregnancy quota rides in the SAME cart/add call as the donor
      // line(s) — its linkage id (__line_item_local_id) is generated client-
      // side, so nothing about it requires the donor line to exist first.
      // Adding it post-add (previous design) opened two real failure windows:
      // a second submit's cart read could land before this one's quota write
      // (both flows then added a quota → double charge), and navigating away
      // right after the donor add aborted the quota request (donor in cart
      // with no quota line — the "silent addon failure" cart-table.liquid
      // works around). One request makes donor+quota atomic both ways.
      // No __line_item_key: unknowable pre-add; the cart-page add path
      // already omits it.
      const pregnancyQuotaInput = this.getPregnancyQuotaInput();

      if (pregnancyQuotaInput.checked) {
        let quotaCovered = false;

        try {
          quotaCovered = await this.hasCartPregnancyQuotaForProduct(formData.get('product_id'));
        } catch (error) {
          console.error('Pregnancy quota pre-check failed:', error);

          if (this.optionsError) {
            this.optionsError.textContent = (window.theme && window.theme.cartError)
              || 'We could not finish adding this to your cart. Please try again.';
            this.optionsError.classList.add('show');
          }

          return;
        }

        if (!quotaCovered) {
          const quotaAnchor = shipItem || bankItem || reservationItem;
          const quotaItem = {
            id: pregnancyQuotaInput.value.split(':')[1],
            quantity: 1,
            properties: {
              __variant_id: quotaAnchor.id,
              __line_item_id: quotaAnchor.id,
              __line_item_local_id: quotaAnchor.properties.__item_local_id,
              'For': window.productData.title
            }
          };

          data.items.push(quotaItem);

          // An exclusive-tier quota brings its nonrefundable fee in the same
          // request, so neither can land in the cart without the other.
          const feeItem = app.pregnancyQuotas.exclusivityFeeLine(quotaItem.id, quotaItem.properties);

          if (feeItem) {
            data.items.push(feeItem);
          }
        }
      }

      config.body = JSON.stringify(data);

      const submit = () => {
        return fetch(window.Shopify.routes.root + 'cart/add.js?' + app.getQueryParamsForCartNotificationSectionsRender(), config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.optionsError.textContent = response.description;
              this.optionsError.classList.add('show');

              return;
            } else if (!cart) {
              window.location = window.routes.cart_url;

              return;
            }

            const addons = [];
            let resultShipItem = null;
            let resultBankItem = null;
            let resultReservationItem = null;
            let resultQuotaItem = null;

            response.items.forEach(responseItem => {
              if (shipItem && responseItem.properties && responseItem.properties.__item_local_id === shipItem.properties.__item_local_id) {
                resultShipItem = responseItem;
              } else if (bankItem && responseItem.properties && responseItem.properties.__item_local_id === bankItem.properties.__item_local_id) {
                resultBankItem = responseItem;
              } else if (reservationItem && responseItem.properties && responseItem.properties.__item_local_id === reservationItem.properties.__item_local_id) {
                resultReservationItem = responseItem;
              } else if (responseItem.product_type === 'PregnancyQuota') {
                resultQuotaItem = responseItem;
              }
            });

            if (formData.get('properties[__genetic_matching]')) {
              if (resultShipItem) {
                // Add genetic matching for ship to clinic
                addons.push({
                  id: resultShipItem.properties.__genetic_matching.split(':')[1],
                  quantity: 1,
                  properties: {
                    __variant_id: resultShipItem.id,
                    __line_item_id: resultShipItem.id,
                    __line_item_local_id: resultShipItem.properties.__item_local_id,
                    'For': resultShipItem.product_title
                  }
                });
              }

              if (resultBankItem) {
                // Add genetic matching for bank storage
                addons.push({
                  id: resultBankItem.properties.__genetic_matching.split(':')[1],
                  quantity: 1,
                  properties: {
                    __variant_id: resultBankItem.id,
                    __line_item_id: resultBankItem.id,
                    __line_item_local_id: resultBankItem.properties.__item_local_id,
                    'For': resultBankItem.product_title
                  }
                });
              }
            }

            document.querySelectorAll('.product-treatment-options-added-treatment').forEach(div => {
              if (resultShipItem) {
                addons.push({
                  id: div.dataset.variantId,
                  quantity: 1,
                  properties: {
                    __treatment_target_local_id: resultShipItem.properties.__item_local_id,
                    'For': resultShipItem.product_title
                  }
                });
              }

              if (resultBankItem) {
                addons.push({
                  id: div.dataset.variantId,
                  quantity: 1,
                  properties: {
                    __treatment_target_local_id: resultBankItem.properties.__item_local_id,
                    'For': resultBankItem.product_title
                  }
                });
              }
            });

            // Reservation adds have no __shipping line; anchor the drawer render on the
            // reservation line instead. Ship/bank keep anchoring on the __shipping line.
            const cartContents = isReservation
              ? resultReservationItem
              : response.items.find(item => !!item.properties.__shipping);
            cartContents.sections = response.sections;

            cart.renderContents(cartContents);

            const rollbackDonorAdd = (errorMessage) => {
              if (this.optionsError) {
                this.optionsError.textContent = errorMessage
                  || (window.theme && window.theme.cartError)
                  || 'We could not finish adding this to your cart. Please try again.';
                this.optionsError.classList.add('show');
              }

              const rollbackKeys = [];
              if (resultShipItem && resultShipItem.key) rollbackKeys.push(resultShipItem.key);
              if (resultBankItem && resultBankItem.key) rollbackKeys.push(resultBankItem.key);
              if (resultReservationItem && resultReservationItem.key) rollbackKeys.push(resultReservationItem.key);
              // The pregnancy quota was added in the same call — a rollback
              // must take it with the donor lines it belongs to.
              if (resultQuotaItem && resultQuotaItem.key) rollbackKeys.push(resultQuotaItem.key);

              if (rollbackKeys.length === 0) {
                return Promise.resolve();
              }

              return rollbackKeys.reduce((prev, key) => {
                return prev.then(() => fetch(window.Shopify.routes.root + 'cart/change.js', {
                  ...fetchConfig('javascript'),
                  body: JSON.stringify({ id: key, quantity: 0 })
                }));
              }, Promise.resolve()).then(() => {
                return fetch(window.Shopify.routes.root + 'cart.json?' + app.getQueryParamsForCartNotificationSectionsRender(), fetchConfig('javascript'))
                  .then(r => r.json())
                  .then(cartData => {
                    if (cart && cartData) {
                      if (cartData.item_count === 0 || (cartData.items && cartData.items.length === 0)) {
                        cart.classList.add('is-empty');
                      }
                      const refreshTarget = cartData.items && cartData.items[0];
                      if (refreshTarget) {
                        refreshTarget.sections = cartData.sections;
                        cart.renderContents(refreshTarget);
                      }
                    }
                  })
                  .catch(err => console.error('rollback cart refresh failed:', err));
              }).catch(err => console.error('rollbackDonorAdd failed:', err));
            };

            const addAddons = () => {
              if (addons.length === 0) {
                return Promise.resolve();
              }

              config.body = JSON.stringify({
                items: addons
              });

              return fetch(window.Shopify.routes.root + 'cart/add.js', config)
                .then((response) => response.json())
                .then((response) => {
                  if (response && response.status) {
                    return rollbackDonorAdd(response.description);
                  }
                })
                .catch((err) => {
                  console.error('addAddons fetch failed:', err);
                  return rollbackDonorAdd();
                });
            }

            // The pregnancy quota was part of the main cart/add call — only
            // genetic matching and treatment addons remain.
            return addAddons();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (cart && cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
          });
      }

      if (!app.getCookie('cart')
        && app.getCookie('cart_currency')
        && app.getCookie('localization')
        && !window.location.hostname.includes('127.0.0.1')
      ) {
        console.log('This session has no cart cookie, forcing one..');

        const data = new URLSearchParams();
        data.append('form_type', 'localization');
        data.append('utf8', '✓');
        data.append('_method', 'put');
        data.append('country_code', app.getCookie('localization'));
        data.append('return_to', window.location.href);

        await fetch('/localization', {
          method: 'post',
          body: data,
        });

        await submit();
      } else {
        await submit();
      }
    }
  });
}